// Importe e monte aqui os seus componentes
// Ex:
//    import Paginacao from './Paginacao/Paginacao.component.vue'
//    
//    Vue.component('paginacao', Paginacao);
import Vue from 'vue'

import Lazyimage	from './LazyImage.vue'
import CategoriasTopo from './Topo/CategoriasTopo.vue'

Vue.component('lazyimage', Lazyimage);
Vue.component('categorias-topo', CategoriasTopo);


// WEBPACK FOOTER //
// ./src/assets/vue/components/index.js